// Auth utility functions

export const setAuth = (token, user) => {
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
};

export const getAuth = () => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || 'null');
  return { token, user };
};

export const clearAuth = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

export const isAuthenticated = () => {
  const { token } = getAuth();
  return !!token;
};

export const getUserRole = () => {
  const { user } = getAuth();
  return user?.role || null;
};

export const getUser = () => {
  const { user } = getAuth();
  return user;
};

export const isAdmin = () => getUserRole() === 'admin';
export const isOwner = () => getUserRole() === 'owner';
export const isUser = () => getUserRole() === 'user';
